<template>
  <el-dialog
    :title="`${rate.carrier_service.name} - ${rate.zone_from.desc} to ${rate.zone_to.desc}: ` + (priceBreak.exists ? 'Edit Existing' : 'Create New') + ' Price Break'"
    visible
    width="80vw"
    top="5vh"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="breakForm"
      v-loading="isSaving"
      :rules="rules"
      :model="priceBreak"
      size="small"
    >
      <el-row :gutter="15">
        <el-col :md="12">
          <el-form-item
            label="Basic"
            prop="basic"
          >
            <el-input-number
              v-model="priceBreak.basic"
              :precision="4"
              controls-position="right"
              placeholder="Basic"
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Break"
            prop="break"
          >
            <el-input-number
              v-model="priceBreak.break"
              controls-position="right"
              placeholder="Break"
              :precision="4"
              class="w-100"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :md="12">
          <el-form-item
            label="Rate"
            prop="cost"
          >
            <el-input-number
              v-model="priceBreak.cost"
              :precision="4"
              controls-position="right"
              placeholder="Rate"
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Rate Type"
            prop="rate_type"
          >
            <el-select
              v-model="priceBreak.rate_type"
              value-key="id"
              filterable
              placeholder="Rate Type"
              :loading="isLoadingRateTypes"
              class="w-100"
              :disabled="!!priceBreak.id"
              clearable
            >
              <el-option
                v-for="rateType in rateTypes"
                :key="rateType.id"
                :label="rateType.full"
                :value="rateType"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="typeof priceBreak.id !== 'undefined' ? updateBreak() : createBreak()"
      >
        {{ typeof priceBreak.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    rate: {
      type: Object,
      required: true
    },
    priceBreak: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      isFullscreen: false,
      rateTypes: [],
      isLoadingRateTypes: false,
      rules: {
        basic: [
          { required: true, message: 'Basic is required', trigger: 'blur' }
        ],
        break: [
          { required: true, message: 'Break is required', trigger: 'blur' }
        ],
        cost: [
          { required: true, message: 'Rate is required', trigger: 'blur' }
        ],
        rate_type: [
          { required: true, message: 'Rate Type is required', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.loadLists()
  },
  methods: {
    loadLists () {
      // Rate Types
      this.isLoadingRateTypes = true
      this.$sdk.dictionary_ratetype.list().then(res => { this.rateTypes = res })
        .finally(() => { this.isLoadingRateTypes = false })
    },
    createBreak () {
      this.$refs.breakForm.validate(valid => {
        if (valid) {
          this.isSaving = true
          this.priceBreak.rate = this.rate
          this.priceBreak.create()
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    updateBreak () {
      this.$refs.breakForm.validate(valid => {
        if (valid) {
          this.isSaving = true
          this.priceBreak.update()
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    }
  }
}
</script>

<style>

</style>
